var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Service Accounts")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/admin/organizations/users/service-accounts/locked/${_vm.tid}`,
                  expression:
                    "`/#/admin/organizations/users/service-accounts/locked/${tid}`",
                },
              ],
              staticClass: "btn btn-link btn-sm",
              attrs: { type: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-lock",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Locked service accounts")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/admin/organizations/users/service-accounts/deleted/${_vm.tid}`,
                  expression:
                    "`/#/admin/organizations/users/service-accounts/deleted/${tid}`",
                },
              ],
              staticClass: "btn btn-link btn-sm",
              attrs: { type: "button" },
            },
            [
              _c("i", {
                staticClass: "fa fa-user-times",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Deleted service accounts")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-success text-white",
              staticStyle: { padding: "0.7em 2em" },
              attrs: {
                href: `/#/admin/organizations/users/create-service-account/${_vm.tid}`,
                role: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Create service account")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("p", { staticClass: "text-muted" }, [
          _vm._v(
            "Service accounts are used for API access and automation. They cannot sign in through the UI."
          ),
        ]),
        _vm._v(" "),
        _vm.serviceAccounts.length
          ? _c("UsersTable", {
              attrs: { users: _vm.serviceAccounts, showActive: false },
            })
          : _c("h4", [_vm._v("No service accounts found")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }